module.exports = __webpack_public_path__ + "static/img/rank_logo_silver.61171076.png";